module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/promos/promo-assign/promo-assign.component.scss
// module id = ./src/app/promos/promo-assign/promo-assign.component.scss
// module chunks = main